import React from "react"
import PropTypes from "prop-types"
import axios from "axios"
import { ToastContainer, toast } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
class Assign extends React.Component {
  constructor(props) {
    super(props);
    this.handleExpert = this.handleExpert.bind(this)
    this.handleValidate = this.handleValidate.bind(this)
    this.state = {
      expert_id: "",
      needValidation: false
    }
  }
  componentDidMount(){
    this.setState({
      expert_id: this.props.expert_id || "",
      needValidation: false
    })
  }
  handleValidate(e){
    e.preventDefault()
    axios.post("/api/v1/admin/rdv/assignExpert",{demande_id: this.props.demande_id,expert_id: this.state.expert_id}).then((data)=>{
      this.setState({needValidation: false})
    })
  }
  handleExpert(e){
    this.setState({
      expert_id: e.target.value,
      needValidation: true
    })
  }
  componentWillUnmount(){
  }
  saveState(e){
    e.preventDefault()
    BienStore.saveState()
  }
  confirmBTN(){
    if(!this.state.needValidation){
      return(
        <div></div>
        )
    }else{
      return(
        <a href="" onClick={this.handleValidate} className="btn"><i className="material-icons left">send</i>Valider</a>
        )
    }
  }

  render () {
    return (
      <React.Fragment>
      <div className="row">
        <div className="col s8">
          <select name="" value={this.state.expert_id} onChange={this.handleExpert} className="browser-default" id="">
            <option value="" disabled> Expert</option>
            {this.props.experts.map((exp)=>(
              <option key={exp.id} value={exp.id}>{exp.prenom} {exp.nom}</option>
              ))}
          </select>
        </div>
        <div className="col s4">
          {this.confirmBTN()}
        </div>
      </div>
      </React.Fragment>
    );
  }
}

export default Assign
